import Button from "../common/Button";
import Pill from "../common/Pill";
import HeroImg from "../../assets/HeroImg.svg";
import Arrow from "../../assets/Arrow.svg";

const HeroSection = () => {
  return (
    <section className=" bg-[#111219] min-h-screen flex flex-col justify-center items-center py-10">
      <div className=" flex sm:flex-row  gap-20   flex-col max-w-6xl mx-auto  items-center px-4">

        <div className="flex flex-col items-center sm:items-start gap-4 md:w-1/2 w-full">
          <Pill text="Powered by leading AI models" backgroundColor="#FFFFFF1A" />

          <h1 className="text-[#E1E1E1] font-semibold text-[32px] leading-[40px] md:text-[45px] md:leading-[56px] max-w-full ">
            The Digital Voice For Every Place
          </h1>

          <p className="text-gray-300  text-sm">
            Turn any QR code into a custom Voice AI agent and provide 
            instant, human-like answers to your customers -- no app required.
            Deliver the information your customers need, 
            at the speed they want them, and modernize your customer interactions.
            From restaurants and cafés to gyms, salons, and retail, even personal use,
            AgoraVoice makes interacting with Voice AI effortless. 
          </p>

          <div className="flex flex-col sm:flex-row gap-[10px] w-full text-center sm:w-auto mt-3">
            <Button text="Try For Free" path="https://app.agoravoice.ai"  />
            <Button text="Watch Demo" path="https://www.youtube.com/watch?v=uL39k1aUzA0&t" />
          </div>
        </div>
        <div className="md:w-1/2 w-full flex justify-center items-center">
          <img
            src={HeroImg}
            alt="HeroImage"
            className="w-[400px] sm:w-[440px]"
          />
        </div>
      </div>

      <div className=" animate-bounce rounded-[70px] mx-auto w-fit h-[60px] px-[15px] py-[20px] mt-20 border  border-[#BF2929]">
        <img src={Arrow} alt="dow arrow" className="w-full" />
      </div>
    </section>
  );
};

export default HeroSection;
